<template>
  <v-navigation-drawer v-model="dialog" fixed temporary right stateless width="900" id="slip-dialog">
    <v-card flat class="drawer-card">
      <v-card-title>
        <div class="title">見積・請求伝票の作成</div>
      </v-card-title>
      <v-card-text class="print-sheet scroll-content">
        <template v-if="editedItem.publish">
          <div class="px-2">
            <div class="publish">
              <v-icon left small dark>fas fa-print</v-icon>
              伝票発行済
            </div>
          </div>
        </template>
        <v-form v-model="valid">
          <v-row no-gutters>
            <v-col cols="12" class="pa-2">
              <v-text-field
                ref="title"
                label="件名"
                v-model="editedItem.title"
                :rules="[rules.required]"
                :disabled="!isEditable"
                class="required"
                outlined hide-details="auto">
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pa-2">
              <v-combobox
                ref="corporate"
                label="発行元"
                v-model="editedItem.corporateID"
                :items="corporateItems"
                :rules="[rules.required]"
                :disabled="!isEditable"
                class="required"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('corporate')"
                @change="corporateChange"
                readonly outlined hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-combobox
                ref="office"
                label="支店・営業所"
                v-model="editedItem.officeID"
                :items="officeItems"
                :disabled="!isEditable"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('office')"
                readonly outlined clearable hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-combobox
                ref="charge"
                label="担当者"
                v-model="editedItem.chargeID"
                :items="chargeItems"
                :disabled="!isEditable"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('charge')"
                readonly outlined clearable hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="12" class="pa-2">
              <v-combobox
                ref="customer"
                label="客先"
                v-model="editedItem.customerID"
                :items="customers"
                :rules="[rules.required]"
                :disabled="!isEditable"
                class="required"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('customer')"
                readonly outlined hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-menu
                v-model="estimateDate"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="from"
                    label="見積日"
                    v-model="editedItem.estimateDate"
                    :rules="[rules.required]"
                    :disabled="!isEditable"
                    class="required"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="editedItem.estimateDate" @input="estimateDate = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-menu
                v-model="orderDate"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="from"
                    label="注文請日"
                    v-model="editedItem.orderDate"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="editedItem.orderDate" @input="orderDate = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-menu
                v-model="claimDate"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="from"
                    label="請求日"
                    v-model="editedItem.claimDate"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="editedItem.claimDate" @input="claimDate = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-menu
                v-model="fixedDate"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="from"
                    label="請求期日"
                    v-model="editedItem.fixedDate"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="editedItem.fixedDate" @input="fixedDate = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-menu
                v-model="paymentDate"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="from"
                    label="入金日"
                    v-model="editedItem.paymentDate"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="editedItem.paymentDate" @input="paymentDate = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-menu
                v-model="deliveryDate"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="from"
                    label="納品日"
                    v-model="editedItem.deliveryDate"
                    v-on="on"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker v-model="editedItem.deliveryDate" @input="deliveryDate = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" class="pa-2">
              <v-text-field
                ref="tax"
                label="消費税"
                type="number"
                v-model="editedItem.tax"
                :disabled="!isEditable"
                :rules="[rules.required, rules.integer, rules.min0, rules.max100]"
                class="required"
                append-icon="fas fa-percentage"
                outlined hide-details="auto">
              </v-text-field>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-combobox
                ref="payment"
                label="支払方法"
                v-model="editedItem.payment"
                :items="payments"
                :rules="[rules.required]"
                :disabled="!isEditable"
                class="required"
                outlined hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-combobox
                ref="estimateLimit"
                label="有効期限"
                v-model="editedItem.estimateLimit"
                :items="limits"
                :disabled="!isEditable"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('estimateLimit', true)"
                readonly outlined clearable hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="6" class="pa-2">
              <v-combobox
                ref="paymentTerms"
                label="支払条件"
                v-model="editedItem.paymentTerms"
                :items="terms"
                :disabled="!isEditable"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('paymentTerms', true)"
                readonly outlined clearable hide-details="auto">
              </v-combobox>
            </v-col>
          </v-row>
          <!-- 品目 -->
          <div class="section-title">品目</div>
          <div class="item-ctrl">
            <ul class="list-inline">
              <li class="px-1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed small v-bind="attrs" v-on="on" @click.stop="copy" :disabled="!isSelected" color="yellow">
                      <v-icon left>far fa-copy</v-icon>コピー
                    </v-btn>
                  </template>
                  <span>コピー</span>
                </v-tooltip>
              </li>
              <li class="px-1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed small v-bind="attrs" v-on="on" @click.stop="paste" :disabled="!clip" color="amber">
                      <v-icon left>far fa-clipboard</v-icon>貼り付け
                    </v-btn>
                  </template>
                  <span>貼り付け</span>
                </v-tooltip>
              </li>
            </ul>
          </div>
          <v-data-table
            :headers="itemHeaders"
            :items="editedItem.items"
            :loading="loading"
            hide-default-footer
            disable-pagination>
            <template v-slot:header.check="{}">
              <v-checkbox
                v-model="selectAll"
                @click.stop="selectAllCheck"
                dense></v-checkbox>
            </template>
            <template v-slot:body="{ items }">
              <draggable 
                v-model="editedItem.items" 
                tag="tbody" 
                handle=".handle"
                class="draggable-table"
                ghost-class="ghost">
                <tr v-for="(item, index) in items" :key="index">
                  <td>
                    <span class="handle">
                      <v-icon small>fas fa-bars</v-icon>
                    </span>
                  </td>
                  <td>
                    <v-checkbox
                      v-model="item.selected"
                      dense></v-checkbox>
                  </td>
                  <td class="py-2">
                    <v-row no-gutters>
                      <v-col cols="12" md="4" class="pa-2">
                        <v-text-field v-model="item.name" 
                          label="品名・品番"
                          :disabled="!isEditable"
                          dense hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="3" md="2" class="pa-2">
                        <v-text-field 
                          label="数量"
                          v-model="item.quantity" 
                          type="number"
                          min="1"
                          class="text-right"
                          :disabled="!isEditable"
                          dense hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="3" md="1" class="pa-2">
                        <v-text-field v-model="item.unit" 
                          label="単位"
                          :disabled="!isEditable"
                          dense hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="6" md="2" class="pa-2">
                        <v-text-field 
                          label="単価"
                          v-model="item.value" 
                          type="number"
                          class="text-right"
                          :disabled="!isEditable"
                          dense hide-details="auto"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" class="pa-2">
                        <template v-if="item.quantity && item.value">
                          <v-text-field 
                            :value="separate(item.quantity * item.value)" class="text-right"
                            disabled dense hide-details="auto"></v-text-field>
                        </template>
                      </v-col>
                      <v-col cols="12" md="9" class="pa-2">
                        <v-text-field v-model="item.remarks" 
                          label="備考"
                          :disabled="!isEditable"
                          dense hide-details="auto"></v-text-field>
                      </v-col>
                    </v-row>
                  </td>
                  <td>
                    <span @click="trash(index)">
                      <v-icon small>fas fa-times</v-icon>
                    </span>
                  </td>
                </tr>
              </draggable>
              <tbody>
                <tr class="table-footer">
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl">
                    <v-row no-gutters>
                      <v-col cols="12" md="9" class="pa-2">
                        <v-btn small text @click.stop="addRow" :disabled="!isEditable">
                          <v-icon left>far fa-plus-square</v-icon>
                          行の追加
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="3" class="pa-2">
                        <v-text-field 
                          label="小計"
                          :value="separate(subtotal)" class="text-right"
                          disabled dense hide-details="auto"></v-text-field>
                      </v-col>
                    </v-row>
                  </td>
                  <td class="row-ctrl"></td>
                </tr>
                <tr class="table-footer" v-if="tax > 0">
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl">
                    <v-row no-gutters>
                      <v-col cols="12" md="9" class="pa-2"></v-col>
                      <v-col cols="12" md="3" class="pa-2">
                        <v-text-field 
                          label="消費税"
                          :value="separate(tax)" class="text-right"
                          disabled dense hide-details="auto"></v-text-field>
                      </v-col>
                    </v-row>
                  </td>
                  <td class="row-ctrl"></td>
                </tr>
                <tr class="table-footer">
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl"></td>
                  <td class="row-ctrl">
                    <v-row no-gutters>
                      <v-col cols="12" md="9" class="pa-2"></v-col>
                      <v-col cols="12" md="3" class="pa-2">
                        <v-text-field 
                          label="合計"
                          :value="separate(total)" class="text-right"
                          disabled dense hide-details="auto"></v-text-field>
                      </v-col>
                    </v-row>
                  </td>
                  <td class="row-ctrl"></td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <!-- 備考 -->
          <div class="section-title">備考</div>
          <v-row no-gutters>
            <v-col cols="12" class="pa-2">
              <v-textarea
                ref="remarks"
                label="備考"
                v-model="editedItem.remarks"
                rows="5"
                :disabled="!isEditable"
                outlined hide-details="auto">
              </v-textarea>
            </v-col>
          </v-row>

        </v-form>

      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid || loading" text x-large>
          <v-icon left>fas fa-save</v-icon>保存
        </v-btn>
        <PDFMake
          :param="editedItem"
          :corporate="corporate"
          :loading="loading"
          :saving="saving"></PDFMake>
        <v-btn color="error" @click="remove" :loading="saving" v-if="editedItem.id" :disabled="loading" text x-large>
          <v-icon left>fas fa-trash-alt</v-icon>削除
        </v-btn>
        <v-btn color="grey darken-2" @click="duplicate" :loading="saving" v-if="editedItem.id" :disabled="loading" text x-large>
          <v-icon left>far fa-copy</v-icon>複製
        </v-btn>
        <v-btn @click="dialog = false" text x-large>
          <v-icon left>fas fa-times</v-icon>閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { 
  createOrder, updateOrder, deleteOrder,
  createOrderItem, updateOrderItem,
  createSequence, updateSequence, deleteOrderItem } from '../graphql/mutations'
import { listAppOptions, getSequence, getOrder } from '../graphql/queries'
import { onUpdateOrder } from '../graphql/subscriptions'
import moment from 'moment'
import draggable from 'vuedraggable' 
import PDFMake from '@/components/PdfMake'
//import { jsPDF } from 'jspdf'
//import html2canvas from 'html2canvas'

export default {
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      appOptions: {},
      itemHeaders: [
        { text: '', align: 'center', value: '', sortable: false, width: 30 },
        { text: '', align: 'center', value: 'check', sortable: false, width: 30 },
        { text: '', align: 'start', value: 'name', sortable: false },
        { text: '', align: 'center', value: '', sortable: false, width: 30 },
      ],
      estimateDate: false,
      orderDate: false,
      claimDate: false,
      fixedDate: false,
      paymentDate: false,
      deliveryDate: false,
      saving: false,
      logoURL: null,
      correctID: null,
      limits: [
        '見積日より2週間',
        '見積日より1ヶ月',
        '見積日より半年',
      ],
      terms: [
        '注文時に支払',
        '納品後に支払',
        '御社指定による',
        '注文時に半金、納品後に半金',
      ],
      origin: [],
      clip: false,
      selectAll: false,
    }
  },
  components: {
    draggable,
    PDFMake,
  },
  props: {
    editedItem: {
      type: Object,
      default: () => ({}),
    },
    customers: {
      type: Array,
      default: () => ([]),
    },
    users: {
      type: Array,
      default: () => ([]),
    },
    corporates: {
      type: Array,
      default: () => ([]),
    },
    payments: {
      type: Array,
      default: () => ([]),
    },
    projectID: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mounted: async function() {
    //設定 query
    const appOptionQuery = await API.graphql(graphqlOperation(listAppOptions, { limit: 500 }))
    for (const row of appOptionQuery.data.listAppOptions.items) {
      this.appOptions[row.name] = row.value
    }
    //クリップボードの監視
    this.unwatch = this.$store.watch(
      (state, getters) => getters.itemsClip,
      (newValue, oldValue) => {
        if (newValue != oldValue) {
          if (newValue.length > 0) {
            this.clip = true
            this.myAlert('コピーしました', 'success')
          } else {
            this.clip = false
            this.myAlert('ペーストしました', 'success')
          }
        }
      }
    )
    //更新時
    await API.graphql(graphqlOperation(onUpdateOrder)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateOrder
        if (row.publish) {
          this.editedItem.publish = row.publish
        }
      }
    })

    this.resetForm()
  },
  beforeDestroy() {
    try {
      this.unwatch()
    } catch (e) {
      //
    }
  },
  computed: {
    subtotal() {
      try {
        let val = 0
        for (const item of this.editedItem.items) {
          if (item.quantity && item.value) {
            val += parseInt(item.quantity) * parseInt(item.value)
          }
        }
        return val

      } catch (e) {
        return 0
      }
    },
    tax() {
      try {
        let val = this.subtotal
        let tax = this.editedItem.tax || 0
        
        return Math.floor(val * (tax / 100))

      } catch (e) {
        return 0
      }
    },
    total() {
      return this.subtotal + this.tax
    },
    form() {
      return {
        id: this.editedItem.id || null,
        title: this.editedItem.title || null,
        estimateDate: this.editedItem.estimateDate || null,
        orderDate: this.editedItem.orderDate || null,
        claimDate: this.editedItem.claimDate || null,
        fixedDate: this.editedItem.fixedDate || null,
        paymentDate: this.editedItem.paymentDate || null,
        complete: this.editedItem.paymentDate ? true : false,
        deliveryDate: this.editedItem.deliveryDate || null,
        projectID: this.editedItem.projectID || this.projectID,
        corporateID: this.editedItem.corporateID ? this.editedItem.corporateID.value: null,
        officeID: this.editedItem.officeID ? this.editedItem.officeID.value: null,
        chargeID: this.editedItem.chargeID ? this.editedItem.chargeID.value: null,
        customerID: this.editedItem.customerID ? this.editedItem.customerID.value: null,
        agencyID: this.editedItem.agencyID ? this.editedItem.agencyID.value: null,
        tax: this.editedItem.tax || null,
        payment: this.editedItem.payment || null,
        estimateLimit: this.editedItem.estimateLimit || null,
        paymentTerms: this.editedItem.paymentTerms || null,
        amount: this.subtotal,
        remarks: this.editedItem.remarks || null,
      }
    },
    corporateItems() {
      const map = []
      for (const item of this.corporates) {
        map.push({
          text: item.name,
          value: item.id
        })
      }
      return map
    },
    officeItems() {
      const map = []

      if (this.editedItem.corporateID) {
        const corporate = this.corporates.find(e => e.id === this.editedItem.corporateID.value)
        for (const item of corporate.office.items) {
          map.push({
            text: item.name,
            value: item.id
          })
        }
      }

      return map
    },
    chargeItems() {
      const map = []

      if (this.editedItem.corporateID) {
        for (const item of this.users) {
          if (item.corporateIDs.find(e => e == this.editedItem.corporateID.value)) {
            map.push(item)
          }
        }
      }

      return map
    },
    corporate() {
      var map
      if (this.corporates.length > 0) {
        map = Object.assign({}, this.corporates[0])
        if (this.editedItem.corporateID) {
          map = Object.assign({}, 
            this.corporates.find(e => e.id === this.editedItem.corporateID.value)
          )
        }
      }
      return map
    },
    isSelected() {
      if (this.editedItem.items) {
        for (const item of this.editedItem.items) {
          if (item.selected) return true
        }
      }

      return false
    },
    isEditable() {
      // return this.editedItem.publish ? false : true
      return true
    },
  },
  watch: {
    show(val) {
      this.dialog = val
    },
    async dialog(val) {
      if (val) {
        if (this.editedItem.id) {
          this.loading = true

          if (this.editedItem.corporateID) {
            this.editedItem.corporateID = this.corporateItems.find(e => e.value === this.editedItem.corporateID)
          }
          if (this.editedItem.officeID) {
            this.editedItem.officeID = this.officeItems.find(e => e.value === this.editedItem.officeID)
          }
          if (this.editedItem.chargeID) {
            this.editedItem.chargeID = this.chargeItems.find(e => e.value === this.editedItem.chargeID)
          }

          //品目の取得
          await this.getOrderItems(this.editedItem.items, this.editedItem.id)

        } else {
          //デフォルトで項目を1行生成
          this.addRow()
          //オリジナルはなし
          this.origin = []
        }
      
      } else {
        this.close()
      }
    },
  },
  methods: {
    async save() {
      try {
        this.saving = true
        const data = Object.assign({}, this.form)
        //編集
        if (data.id) {
          await API.graphql(graphqlOperation(updateOrder, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.id + '] を更新しました' })

        //新規
        } else {
          data.id = await this.createOrderID()
          this.editedItem.id = data.id
          await API.graphql(graphqlOperation(createOrder, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.id + '] を追加しました' })
        }

        //品目の保存
        let cnt = 0
        for (const item of this.editedItem.items) {
          const model = this.getModel(item)
          model.sort = cnt++
          if (item.id) {
            await API.graphql(graphqlOperation(updateOrderItem, {input: model}))
          } else {
            delete model.id
            const ret = await API.graphql(graphqlOperation(createOrderItem, {input: model}))
            item.id = ret.data.createOrderItem.id
          }
        }
        //オリジナルにのみ存在するものは削除
        for (const model of this.origin) {
          if (!this.editedItem.items.find(e => e.id === model.id)) {
            await API.graphql(graphqlOperation(deleteOrderItem, {
              input: { id: model.id }
            }))
          }
        }
        
        this.myAlert('見積・請求伝票を保存しました', 'success')
        this.saving = false

      } catch (error) {
        this.myAlert(error.message)
        this.saving = false
      }
    },
    //削除
    async remove() {
      try {
        if (confirm(this.editedItem.id + 'を削除しますか？')) {
          //削除
          await API.graphql(graphqlOperation(deleteOrder, {
            input: { id: this.editedItem.id }
          }))
          for (const item of this.editedItem.items) {
            if (!item.id) continue
            await API.graphql(graphqlOperation(deleteOrderItem, {
              input: { id: item.id }
            }))
          }
          this.log({ type: this.$route.name, text: '[' + this.editedItem.id + '] を削除しました' })
          this.myAlert(this.editedItem.id + 'を削除しました', 'success')
          this.dialog = false
        }
      } catch (error) {
        this.myAlert(error)
      }
    },
    // 複製
    async duplicate() {
      try {
        if (confirm('同じ内容で伝票を複製しますか？')) {
          this.saving = true
          const data = Object.assign({}, this.form)
          
          data.id = await this.createOrderID()
          this.editedItem.id = data.id

          data.title = data.title + ' - コピー'
          data.estimateDate = moment().format('YYYY-MM-DD')
          data.claimDate = null
          data.deliveryDate = null
          data.fixedDate = null
          data.orderDate = null
          data.paymentDate = null
          data.publish = false
          
          await API.graphql(graphqlOperation(createOrder, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.id + '] をコピーとして作成しました' })

          //品目の保存
          let cnt = 0
          for (const item of this.editedItem.items) {
            const model = this.getModel(item)
            model.sort = cnt++
            
            delete model.id
            const ret = await API.graphql(graphqlOperation(createOrderItem, {input: model}))
            item.id = ret.data.createOrderItem.id
          }
          
          this.myAlert('見積・請求伝票を複製しました', 'success')
          this.saving = false

          this.close()
        }

      } catch (error) {
        this.myAlert(error.message)
        this.saving = false
      }
    },
    //品目の取得
    async getOrderItems(target, orderID) {
      const ret = await API.graphql(graphqlOperation(getOrder, { id: orderID }))
      const items = ret.data.getOrder.orderItems.items

      for (const item of items) {
        target.push(item)
      }
/*
      const values = await API.post(
        'restapi', 
        '/queryOrderItems', 
        {
          body: {
            orderID: orderID
          },
          headers: {
            'Content-Type' : 'application/json',
          }
        }
      )
      for (const item of values.data.items) {
        target.push(item)
      }
*/
      //オリジナルをコピーしておく
      this.origin = [...target]
      //作成日付降順でソート
      target.sort(function(a,b) {
        if (a.sort < b.sort) return -1
        if (a.sort > b.sort) return 1
        return 0
      })

      this.loading = false
    },
    //品目
    getModel(item) {
      return {
        id: item.id || null,
        orderID: this.editedItem.id || null,
        modelID: item.modelID || null,
        subModelID: item.modelID || null,
        name: item.name || null,
        quantity: item.quantity || null,
        unit: item.unit || null,
        value: item.value || null,
        remarks: item.remarks || null,
      }
    },
    //伝票Noの生成
    async createOrderID() {
      //let count = 1
      const name = 'ORDER_' + (this.appOptions.orderDateFormat ? moment().format(this.appOptions.orderDateFormat) : '')
      const tag = 'Order'

      //連番キーがあるか
      const find = await API.graphql(graphqlOperation(getSequence, {
        name: name,
        tag: tag,
      }))

      const data = {
        name: name,
        tag: tag,
        count: find.data.getSequence ? find.data.getSequence.count + 1 : 1,
      }

      if (find.data.getSequence) {
        await API.graphql(graphqlOperation(updateSequence, { input: data }))
      } else {
        await API.graphql(graphqlOperation(createSequence, { input: data }))
      }

      //伝票Noの生成
      const prefix = this.appOptions.orderPrefix || ''
      const dateFormat = this.appOptions.orderDateFormat ? moment().format(this.appOptions.orderDateFormat) : ''
      const noDigit = this.appOptions.orderNoDigit || null
      const digit = noDigit ? this.zeroPadding(data.count, parseInt(noDigit)) : data.count
      const orderID = prefix + dateFormat + digit

      return orderID
    },
    //ダイアログclose
    close() {
      this.saving = false
      this.$emit('close')
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
        this.selectAll = false
        //スクロールリセット
        let container = document.getElementById('slip-dialog').getElementsByClassName('v-navigation-drawer__content')[0]
        container.scrollTop = 0
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f] && !!this.$refs[f].reset) this.$refs[f].reset()
      })
      this.editedItem.id = null
      this.editedItem.items = []
      //スクロールのリセット
      this.scrollReset()
    },
    //スクロールを戻す
    scrollReset() {
      let container = document.getElementsByClassName('scroll-content')[0]
      container.scrollTop = 0
    },
    //印刷
    print() {
      window.print();
    },
    //ゼロ埋め
    zeroPadding(num, len) {
      return (Array(len).join('0') + num).slice(-len)
    },
    //品目の追加
    addRow() {
      this.editedItem.items.push({
        name: null,
        quantity: null,
        unit: null,
        value: null,
        remarks: null,
      })
    },
    //品目の削除
    trash(index) {
      this.editedItem.items.splice(index, 1)
    },
    //全選択
    selectAllCheck() {
      for (const item of this.editedItem.items) {
         this.$set(item, 'selected', this.selectAll)
      }
    },
    //発行元の変更
    corporateChange() {
      this.editedItem.officeID = null
      this.editedItem.chargeID = null
    },
    //コピー
    copy() {
      if (this.editedItem.items.length > 0) {
        const map = []
        for (const item of this.editedItem.items) {
          if (item.selected) {
            map.push({
              modelID: item.modelID,
              name: item.name,
              quantity: item.quantity,
              subModelID: item.subModelID,
              unit: item.unit,
              value: item.value,
              remarks: item.remarks,
            })
          }
        }
        //クリップボードに保持
        this.$store.dispatch('updateItemsClip', map)
      }
    },
    //ペースト
    paste() {
      for (const item of this.$store.getters.itemsClip) {
        this.editedItem.items.push(item)
      }
      //クリップボードを消す
      this.$store.dispatch('updateItemsClip', [])
    },
  },
}
</script>

<style lang='scss' scoped>
.section-title {
  margin: 10px 0;
  padding: 5px 10px;
  font-weight: bold;
  background: #e1ecf3;
}
tbody {
  tr {
    &:hover {
      background: transparent !important;
    }
    &.ghost {
      opacity: 0.5 !important;
      background: #c8ebfb !important;
    }
    td {
      .handle {
        &:hover {
          cursor: move;
        }
      }
      
    }
  }
}
.table-footer {
  &:first-of-type td {
    border-top: thin solid rgba(0, 0, 0, 0.12);
  }
  &:hover {
    background: #FFF !important;
  }
  td {
    cursor: default !important;
    &.row-ctrl {
      vertical-align: top;
      padding-top: 10px;
      border-bottom: none !important;
    }
  }
}
.item-ctrl {
  text-align: left;
}
.checkbox-wrap {
  width: 30px;
}
.publish {
  color: #FFF;
  background:#fb8c00;
  border-radius: 5px;
  padding: 5px 15px;
  display: inline-block;
  margin-bottom: 10px;
}
</style>
